module.exports = __webpack_public_path__ + "static/media/Bio9.69b51016.png";